import { getCookie, setCookie } from "./cookies"
import { CookieAccepted, CookieName, cookies, requiredCookies } from "./cookieTypes"
import { ConsentMapping, defaultContent, FullConsentUpdate, gtag } from "./datalayer.consent"

export type CookieStatus = "not_touched" | "accepted" | "denied" | "changing"

export const getCookieStatus: () => Exclude<CookieStatus, "changing">  = () =>
  getCookie("cookies") === "accepted" ? "accepted" : getCookie("cookies") === "denied" ? "denied" : "not_touched"

export const acceptCookies = (): void => {
  setCookie("cookies", "accepted", 1000)
  
  const cookies: Map<CookieName, CookieAccepted> = new Map(
    ([
      ['functional-cookies', 'yes'],
      ['analytical-cookies', 'yes'],
      ['video-cookies', 'yes'],
      ['tracking-cookies', 'no'],
    ] as [CookieName, CookieAccepted][])
  );
  
  setConsentCookie(cookies)
}

export const denyCookies = (): void => {
  setCookie("cookies", "denied", 1000)

  const cookies: Map<CookieName, CookieAccepted> = new Map(
    ([
      ['functional-cookies', 'yes'],
      ['analytical-cookies', 'yes'],
      ['video-cookies', 'no'],
      ['tracking-cookies', 'no'],
    ] as [CookieName, CookieAccepted][])
  );
  
  setConsentCookie(cookies)
}


const cookieToModeMapping: ConsentMapping<CookieName> = { 
  'analytical-cookies': ['analytics_storage'], 
  'functional-cookies': ['functionality_storage', 'security_storage'], 
  'video-cookies': [], 
  'tracking-cookies': ['personalization_storage', 'ad_personalization', 'ad_storage', 'ad_user_data'], 
} 

export const getCurrentCookies: () => Map<CookieName, CookieAccepted> = () =>
  new Map(cookies.map((cookie) => [cookie, getCookie(cookie) === 'yes' || requiredCookies.includes(cookie) ? 'yes' : 'no']))

export const updateConsent = (cookies: Map<CookieName, CookieAccepted>) => {
  const data: FullConsentUpdate = defaultContent
  cookies.forEach((isAccepted, cookie) => {
    var modes = cookieToModeMapping[cookie]
    modes.forEach(mode => data[mode] = isAccepted == 'yes' ? 'granted' : 'denied')
  })
  gtag('consent', 'update', data);
}

export const setConsentCookie = (cookies: Map<CookieName, CookieAccepted>) => { 
  updateConsent(cookies) 
  cookies.forEach((isAccepted, cookie) => setCookie(cookie, isAccepted, 1000))
} 

export function updateInitialConsent () {
  updateConsent(getCurrentCookies())
}

window.updateInitialConsent = updateInitialConsent